<header>
  <div class="header-brand">
    <a class="logo-container" routerLink="dashboard">
      <svg class="ts-logo" aria-hidden="true" />
      <h2>Hephaestus</h2>
    </a>
    <button
      cuiButton
      square
      variant="plain"
      type="button"
      aria-label="About Hephaestus"
      (click)="openAbout()">
      <span class="material-symbols-outlined" aria-hidden="true">info</span>
    </button>
  </div>
  @if (isUserLoggedIn()) {
    <div class="header-actions">
      <button cuiButton [cuiDropdownTriggerFor]="accountDropdown" variant="plain">
        <span class="material-symbols-outlined">account_circle</span>
        {{ user()?.userName }}
      </button>
      <cui-dropdown #accountDropdown>
        <button
          cuiButton
          cdkMenuItem
          class="cui-dropdown__item"
          variant="plain"
          (click)="handleSettings()">
          <span class="material-symbols-outlined">settings</span>
          Settings
        </button>
        <button
          cuiButton
          cdkMenuItem
          class="cui-dropdown__item"
          variant="plain"
          (click)="handleLogout()">
          <span class="material-symbols-outlined">logout</span>
          Logout
        </button>
      </cui-dropdown>
      @if (user()?.canAccessChat) {
        @if (chatWindow.mode() === 'fullscreen') {
          <button
            cuiButton
            square
            variant="plain"
            type="button"
            aria-label="Close fullscreen chat"
            (click)="chatWindow.closeFullscreen()">
            <span class="material-symbols-outlined" aria-hidden="true">close</span>
          </button>
        } @else {
          <button
            cuiButton
            square
            variant="plain"
            type="button"
            [attr.aria-label]="
              chatWindow.mode() === 'sidebar' ? 'Hide chat panel' : 'Show chat panel'
            "
            [attr.aria-pressed]="chatWindow.mode() === 'sidebar'"
            (click)="chatWindow.togglePanel()">
            <span class="material-symbols-outlined" aria-hidden="true">
              {{ chatWindow.mode() === 'sidebar' ? 'right_panel_close' : 'right_panel_open' }}
            </span>
          </button>
        }
      }
    </div>
  }
</header>
